import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import CollaboratorReport from './CollaboratorReport';
import * as reportAction from '../../../../../actions/reportAction';

const mapStateToProps = state => {
    return {
        collaboratorState: state.reportReducer.collaboratorReport,
        loadingCollaborator: state.reportReducer.isFetchingCollaborator,
        isFetchingCrossCheck: state.reportReducer.isFetchingCrossCheck,
        isCrossCheckStatus: state.reportReducer.isCrossCheckStatus,
        isFetchingExportCollaborator: state.reportReducer.isFetchingExportCollaborator
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCollaboratorReport: (filters) => dispatch(reportAction.getCollaboratorReport(filters)),
        crossCheckPMS: (body) => dispatch(reportAction.crossCheckPMSAction(body)),
        setDefaultStatusCrossCheck: () => dispatch(reportAction.setDefaultCrossCheckStatus()),
        getExportCollaboratorReport: (data) => dispatch(reportAction.getExportCollaboratorReport(data)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CollaboratorReport));
